import script from "./CustomerSelectLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSelectLocation.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSelectLocation.vue?vue&type=style&index=0&id=2f0594af&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0594af"]])

export default __exports__